import { SG_ODD_SCREEN_NAMES } from '../../../screens/RFI/singpass-ekyc/ScreenConstants';
import {
  CLEAR_RFI_STORE,
  SET_RFI_SG_KYC_SCREEN,
  SET_RFI_SG_KYC_DATA,
  TOGGLE_LOAD_PERSONAL_DATA,
  SET_SELECTED_FLOW_TYPE,
  SET_TEMP_RFI_FORM_VALUES,
  SET_JUMIO_AVAILABILITY,
  SET_SELECTED_ADDRESS_DOCUMENT
} from '../../action-contants';

const { landing_page } = SG_ODD_SCREEN_NAMES;

type actionType = {
  [key: string]: any;
};
const INITIAL_STATE = {
  sgKycFlow: {
    currentScreen: landing_page,
    loadPersonalData: false,
    selectedFlowType: null,
    isJumioAvailable: false,
    nestedFieldsJson: [],
    renderingObject: null,
    rfiDetails: null,
    tempRfiFormValues: null,
    selectedAddressDoc: null
  }
};

export default function rfiReducer(state = INITIAL_STATE, action: actionType) {
  switch (action.type) {
    case CLEAR_RFI_STORE: {
      return INITIAL_STATE;
    }

    case SET_RFI_SG_KYC_SCREEN: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          currentScreen: action.data
        }
      };
    }

    case SET_RFI_SG_KYC_DATA: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          nestedFieldsJson: action.data.nestedFieldsJson,
          renderingObject: action.data.renderingObject,
          rfiDetails: action.data.rfiDetails
        }
      };
    }

    case TOGGLE_LOAD_PERSONAL_DATA: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          loadPersonalData: action.data
        }
      };
    }

    case SET_SELECTED_FLOW_TYPE: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          selectedFlowType: action.data
        }
      };
    }

    case SET_TEMP_RFI_FORM_VALUES: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          tempRfiFormValues: action.data
        }
      };
    }

    case SET_JUMIO_AVAILABILITY: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          isJumioAvailable: action.data
        }
      };
    }

    case SET_SELECTED_ADDRESS_DOCUMENT: {
      return {
        ...state,
        sgKycFlow: {
          ...state.sgKycFlow,
          selectedAddressDoc: action.data
        }
      };
    }

    default:
      return state;
  }
}
